// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1SQEs","notes":"Notes_notes__38eKC","note":"Notes_note__3xQNG","markdown":"Notes_markdown__2cUaA"};